export default __webpack_public_path__ + "static/media/resetpassword.40817561.png";